import type { PluginProductCode } from './types';

const PLUGIN_MAP: Record<PluginProductCode, string> = {
    'PI-CAREVAL': 'plugin-sleasingmobilitycockpit',
    'PI-MOBILEPAYMENTS': 'plugin-mobilepayments',
    'PI-PREPAID': '',
    'PI-SEARCHPL': 'plugin-searchplus',
    'PI-BANKCONN': 'plugin-multibanking',
    'PI-DATACARR': 'plugin-datacarrier',
};

export function getDirectoryByPluginId(pluginId: PluginProductCode): string {
    return PLUGIN_MAP[pluginId];
}
